import React from "react"
import { Modal, Button } from "antd"
import PropTypes from "prop-types"
import styles from "./index.module.css"
const NoExperiencesDeleteDeactivateModal = ({
  open,
  title,
  description,
  boldText,
  afterBoldText,
  onCancel,
  onOk,
  okText = "Deactivate",
  cancelText = "Cancel",
  okButtonProps = {},
  cancelButtonProps = {},
  loading = false
}) => (
  <Modal open={open} title={title} onCancel={onCancel} footer={null} centered closable style={{ borderRadius: 16 }} width={500} maskClosable={false}>
    <div className={styles.description}>
      {description}
      {boldText && <strong className={styles.boldText}>{boldText}</strong>}
      {afterBoldText}
    </div>
    <div className={styles.footer}>
      <Button onClick={() => onCancel()} {...cancelButtonProps} variant="outlined" color="primary">
        {cancelText}
      </Button>
      <Button type="primary" onClick={() => onOk()} loading={loading} {...okButtonProps} variant="solid" color="danger">
        {okText}
      </Button>
    </div>
  </Modal>
)

NoExperiencesDeleteDeactivateModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  boldText: PropTypes.node,
  afterBoldText: PropTypes.node,
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  okButtonProps: PropTypes.object,
  cancelButtonProps: PropTypes.object,
  loading: PropTypes.bool
}

export default NoExperiencesDeleteDeactivateModal
